/**
 * Standardized date formatting options
 */
export interface DateFormatOptions {
  language?: string;
  timezone?: string;
  dateStyle?: 'full' | 'long' | 'medium' | 'short';
  timeStyle?: 'full' | 'long' | 'medium' | 'short';
  includeTime?: boolean;
}

/**
 * Formats a date string or object into a standardized string format.
 * Defaults to 'short' date style and browser language if not specified.
 */
export const formatDate = (
  date: string | Date | undefined | null,
  options: DateFormatOptions = {},
): string => {
  if (!date) return 'N/A';

  const {
    language = typeof navigator !== 'undefined' ? navigator.language : 'en-US',
    timezone,
    dateStyle = 'short',
    timeStyle = options.includeTime ? 'medium' : undefined,
  } = options;

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    // Check for invalid date
    if (isNaN(dateObj.getTime())) return 'N/A';

    return new Intl.DateTimeFormat(language, {
      timeZone: timezone,
      dateStyle,
      ...(timeStyle ? { timeStyle } : {}),
    }).format(dateObj);
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'N/A';
  }
};
